'use client';

import Script from 'next/script';

import { SubjectID } from '@common/clients/api';
import { useContextData } from '@common/useContextData';
import { useEmbedConsented } from '@web/hooks/useEmbedConsented';

const includedSubjects: SubjectID[] = [SubjectID.LIFESTYLE, SubjectID.TECH];

export const WeCanTrackPixelClient = () => {
    const contextData = useContextData();
    const { consented } = useEmbedConsented('wecantrack');

    if (
        contextData.allowTracking === false ||
        !includedSubjects.includes(contextData.context.subject) ||
        !consented
    ) {
        return null;
    }

    return (
        <Script
            id="wecantrack-pixel"
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
                __html: `
                    !(function(w, c, t, u) {
                        w._wct = w._wct || {}; w._wct = u;
                        var s = c.createElement(t);
                        s.type = 'text/javascript'; s.async = true; s.src = 'https://wct-2.com/wct.js?type=session';
                        var r = c.getElementsByTagName(t)[0];
                        r.parentNode.insertBefore(s, r);
                    }(window, document, 'script', {
                        'uid' : 'HMdTIv',
                        'proxy' : 'https://wct-2.com',
                        'auto_tagging' : true
                    }));
                `,
            }}
        />
    );
};
